import pkg from "../../package.json";

export const CLI_VERSION: string = pkg.version;
